import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 347,
	height: 481,
	viewBox: "0 0 347 481",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M278.85 215.95L280.37 161.62L195.29 207.59L205.16 281.25L176.68 307.46L176.19 47.26V0L310.76 84.52L329.75 228.85L296.33 244.8L323.68 253.17L346.47 328.37L196.05 480.3L220.35 234.56L268.6 203.42L278.85 215.96V215.95ZM136.5 21.21L170.27 0V47.29L169.78 307.49L141.3 281.28L151.18 207.6L66.09 161.63L67.63 215.96L77.86 203.41L126.11 234.55L150.42 480.29L125.28 454.9V429.21H99.85L51.75 380.63V363.71H35.01L17.62 346.14H44.7V318.67H17.51V346.04L0 328.37L7.07 305.03H44.67V277.58H15.43L22.81 253.18L50.16 244.81L16.73 228.86L26.69 153.02H73.35V126.82H30.25L35.83 84.44L47.01 77.44V100.43H73.42V74.14H52.25L74.7 60.03H110.4V86.27H136.12V59.98H110.46V37.55L117.27 33.28H136.47V59.49H163.32V33.2H136.5V21.22V21.21ZM116.35 367.64H94.77V343.02H70.25V392.25H116.35V367.63V367.64ZM97.01 305.58V278.39H70.1V305.58H97.01ZM123.92 305.56H97.01V332.75H123.92V305.56ZM44.67 253.32V277.6H68.71V253.34H100.41V229.47H68.64V253.31H44.66L44.67 253.32ZM151.62 126.74H125.89V100.44H73.48V126.75H125.87V153.03H151.62V126.74Z",
		fill: "white"
	})
});
export default SvgIconWhite;
